export default "__VITE_ASSET__6jkIR43___"